import DOMPurify from 'dompurify';
import MarkdownIt from 'markdown-it';

// Конфиг подобран под рендер публичного сайта (react-markdown + remark-breaks):
//   html: true    — сырой HTML в markdown (как rehype-raw)
//   breaks: true  — одиночный перевод строки -> <br> (как remark-breaks)
//   linkify: false — не автолинкуем «голые» URL (на сайте нет remark-gfm)
const md = new MarkdownIt({ html: true, breaks: true, linkify: false });

// MDXEditor местами сериализует переводы строк как HTML-сущности (&#xA;),
// из-за чего блоки «слипаются». Декодируем ДО парсинга (markdown-it, как и
// react-markdown, декодирует сущности только внутри текста, не разбивая блоки).
const decodeLineEntities = (md: string): string =>
	md.replace(/&#x0*a;/gi, '\n').replace(/&#0*10;/g, '\n');

// dompurify вырезает опасные теги/атрибуты (script, onerror, javascript:) —
// граница безопасности рендера, как rehype-sanitize на сайте.
export const renderMarkdown = (markdown: string): string =>
	DOMPurify.sanitize(md.render(decodeLineEntities(markdown || '')));
